var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "Image", on: { click: _vm.showVideo } }, [
        _c("img", { staticClass: "avatar-url", attrs: { src: _vm.imgUrl } }),
      ]),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.visible,
            destroyOnClose: "",
            title: _vm.title,
            onText: "关闭",
            width: 500,
            height: 500,
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.visible = false
            },
          },
        },
        [
          _c("video-player", {
            ref: "videoPlayer",
            staticClass: "video-player vjs-custom-skin",
            attrs: { playsinline: true, options: _vm.playerOptions },
          }),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                {
                  key: "submit",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(" 关闭 ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }